import { CHANGE_LOCATION_FILTER, CLEAR_MULTI_FILTER,CHANGE_MODAL_MULTI_FILTER,CHANGE_MODAL_PROPERTY_TYPE, TOGGLE_FILTER, CHANGE_SORTING, CHANGE_POPULAR_CITY, CHANGE_PAGE, SELECT_SEARCHED_RESULT, CHANGE_SEARCH_CONTENT, CHANGE_SPECIAL_FEATURE, CLEAR_SEARCH_CONTENT, CHANGE_PROPERTY_TYPE, CHANGE_PROPERTY_SUB_TYPE, CHANGE_TO_ANY, CLEAR_ALL, RESET_PAGE_NO, FOOTER_LOC } from "./filterConstants"

export const changeLocationFilter = (payload) => {
    return {
        type: CHANGE_LOCATION_FILTER,
        payload
    }
}

// export const onToggleFilter = (p0: string) => {
//     return {
//         type: TOGGLE_FILTER
//     }
// }
export const onToggleFilter = () => {
    return {
        type: TOGGLE_FILTER
    }
}

export const changeModalPropertyType = (payload) => {
    return {
        type: CHANGE_MODAL_PROPERTY_TYPE,
        payload
    }
}

export const changeModelMultiFilter = (payload) => {
    return {
        type: CHANGE_MODAL_MULTI_FILTER,
        payload
    }
}

export const changePopularCity = (payload) => {
    return {
        type: CHANGE_POPULAR_CITY,
        payload
    }
}

export const changePage = (payload) => {
    return {
        type: CHANGE_PAGE,
        payload
    }
}

export const changeSorting = (payload) => {
    return {
        type: CHANGE_SORTING,
        payload
    }
}

export const clearMultiFilter = () => {
    return {
        type: CLEAR_MULTI_FILTER
    }
}

export const setSearchedResult = (data) => {
    return {
        type: SELECT_SEARCHED_RESULT,
        payload:data
    }
}

export const setSearchedContent = (data) => {
    return {
        type: CHANGE_SEARCH_CONTENT,
        payload:data
    }
}

export const changeSpecialFeature = (data) => {
    return {
        type: CHANGE_SPECIAL_FEATURE,
        payload:data
    }
}

export const clearSearchContent = () => {
    return {
        type: CLEAR_SEARCH_CONTENT
    }
}

export const changePropertyType = (data) => {
    return {
        type: CHANGE_PROPERTY_TYPE,
        payload:data
    }
}

export const changeSubPropertyType = (data) => {
    return {
        type: CHANGE_PROPERTY_SUB_TYPE,
        payload:data
    }
}

export const changeToAny = () => {
    return {
        type: CHANGE_TO_ANY
    }
}

export const clearAll = () => {
    return {
        type: CLEAR_ALL
    }
}

export const resetPageNo = () => {
    return {
        type: RESET_PAGE_NO
    }
}

export const changeFooterFilterPara = (data) => {
    return {
        type: FOOTER_LOC,
        payload:data
    }
}